export default __webpack_public_path__ + "images/4A.13b2afd.png";